<template>
    <div class="search-input__wrapper">
        <input class="search-input" type="text" :placeholder="placeholderText" v-model="searchValue" @input="handleSearch" />

        <i v-if="!!searchValue" class="clear-icon fas fa-times" @click="clearSearch"></i>
    </div>
</template>

<script>
import _debounce from 'lodash/debounce';

export default {
    name: 'SearchInput',
    props: {
        placeholderText: {
            type: String,
            default: 'Search',
        },
    },
    data() {
        return {
            searchValue: null,
        };
    },
    methods: {
        handleSearch(e) {
            let searchString = e.target.value;
            this.searchValue = searchString;
            this.debouncedSearch(searchString);
        },
        debouncedSearch: _debounce(function (searchString) {
            this.$emit('handleSearch', searchString);
        }, 1200),
        clearSearch() {
            this.searchValue = null;
            this.$emit('hadleSearch', '');
        },
    },
};
</script>
